import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { map, of, switchMap, catchError, Observable } from 'rxjs';

import { ParentQuestionService } from '../services/parent-question.service';
import {
  ParentQuestion,
  SearchQuestionsParams,
} from '../models/parent-question.model';
import { QuestionActions } from './question.actions';

@Injectable()
export class QuestionSearchEffects {
  private readonly _actions$ = inject(Actions);
  private readonly _parentQuestionService = inject(ParentQuestionService);

  public readonly searchParentQuestions$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(QuestionActions.searchParentQuestions),
      switchMap(({ params }) =>
        this._searchQuestions(params, (results) =>
          QuestionActions.searchParentQuestionsSuccess({ results }),
        ),
      ),
    );
  });

  public readonly searchChildQuestions$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(QuestionActions.searchChildQuestions),
      switchMap(({ params }) =>
        this._searchQuestions(params, (results) =>
          QuestionActions.searchChildQuestionsSuccess({ results }),
        ),
      ),
    );
  });

  private _searchQuestions(
    params: SearchQuestionsParams,
    toSuccessAction: (results: ParentQuestion[]) => Action,
  ): Observable<Action> {
    return this._parentQuestionService.searchQuestions(params).pipe(
      map((results) => toSuccessAction(results)),
      catchError(() => of(toSuccessAction([]))),
    );
  }
}
